import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { LangProvider } from "./LangContext";
import Header from "./sections/Header";
import Hero from "./sections/Hero";
import About from "./sections/About";
import Services from "./sections/Services";
import Pricing from "./sections/Pricing";
import FAQ from "./sections/FAQ";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";
import CookieBanner from "./sections/CookieBanner";
import ConnectCalendar from "./pages/ConnectCalendar";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancelled from "./pages/PaymentCancelled";

const Home = () => (
  <main className="grain bg-cream text-ink">
    <Header />
    <Hero />
    <Services />
    <About />
    <Pricing />
    <FAQ />
    <Contact />
    <Footer />
    <CookieBanner />
  </main>
);

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/connect-calendar" element={<ConnectCalendar />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancelled" element={<PaymentCancelled />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
